import { createFileRoute, Outlet } from '@tanstack/react-router';
import { McpClientsPage } from '@/pages/mcp-clients';
import { mcpClientsSearchSchema } from '@/routes/-shared/mcpClientsSearchSchema';
import { requireSuperadmin } from '@/routes/-shared/require-superadmin';

/**
 * La lista dei client resta montata e il dettaglio si apre sopra di lei
 * sull'`Outlet` (`$id`): il link al client si condivide e Indietro chiude il
 * pannello. Solo i SUPERADMIN gestiscono i client MCP (le API rispondono 403
 * a SYSTEM): il guard sul layout vale anche per il dettaglio.
 */
export const Route = createFileRoute('/admin/_layout/mcp-clients/_layout')({
  beforeLoad: requireSuperadmin,
  component: McpClientsLayout,
  validateSearch: mcpClientsSearchSchema,
});

function McpClientsLayout() {
  return (
    <>
      <McpClientsPage />
      <Outlet />
    </>
  );
}
